import { DtoBase } from "./DtoBase";
export class UserAuthDto extends DtoBase {
}
export var ChannelType;
(function (ChannelType) {
    ChannelType["NORMAL"] = "Normal";
    ChannelType["GOOGLE"] = "Google";
    ChannelType["APPLE"] = "Apple";
})(ChannelType || (ChannelType = {}));
export var loginFlow;
(function (loginFlow) {
    loginFlow["OTP"] = "Otp";
    loginFlow["PASSWORD"] = "Password";
    loginFlow["MASTER"] = "Master";
})(loginFlow || (loginFlow = {}));
